import React, { useRef, useState, useCallback } from "react";
import QrScanner from "qr-scanner";
import ButtonIcon from "../buttons/buttonIcon/ButtonIcon";
import { FaQrcode } from "react-icons/fa";
import colors from "../../config/colors";

function QRCodeScanner({ onScanResult }) {
  const videoElementRef = useRef(null);
  const qrScannerRef = useRef(null); // Store QrScanner instance
  const [scanned, setScannedText] = useState("");
  const [user, setUser] = useState(null);
  const [regno, setRegno] = useState(null);
  const [isScannerActive, setIsScannerActive] = useState(false);

  // Initialize scanner only once
  const initializeScanner = useCallback(async () => {
    if (qrScannerRef.current || !videoElementRef.current) return;

    try {
      const qrScanner = new QrScanner(
        videoElementRef.current,
        (result) => {
          const scannedData = result?.data;
          setScannedText(scannedData);

          try {
            const url = new URL(scannedData);
            const queryParams = new URLSearchParams(url.search);
            const scannedUser = queryParams.get("user");
            const scannedRegno = queryParams.get("regno");

            if (!scannedUser || !scannedRegno) {
              onScanResult({ user: null, regno: null });
              qrScanner.stop(); 
              setIsScannerActive(false);
            }

            setUser(scannedUser);
            setRegno(scannedRegno);

            if (scannedUser && scannedRegno) {
              onScanResult({ user: scannedUser, regno: scannedRegno });
              qrScanner.stop(); // Stop after successful scan
              setIsScannerActive(false);
            }
          } catch (parseError) {
          }
        },
        {
          returnDetailedScanResult: true,
          highlightScanRegion: true,
          highlightCodeOutline: true,
        }
      );

      qrScannerRef.current = qrScanner;
      await qrScanner.start();
      setIsScannerActive(true);
    } catch (error) {
    }
  }, [onScanResult]);

  // Start scanner when explicitly triggered
  const startScanner = useCallback(() => {
    if (!qrScannerRef.current) {
      initializeScanner();
    } else if (!isScannerActive) {
      qrScannerRef.current.start();
      setIsScannerActive(true);
    }
  }, [initializeScanner, isScannerActive]);

  // Stop scanner manually
  const stopScanner = useCallback(() => {
    if (qrScannerRef.current && isScannerActive) {
      qrScannerRef.current.stop();
      setIsScannerActive(false);
    }
  }, [isScannerActive]);

  // Cleanup on unmount
  React.useEffect(() => {
    return () => {
      if (qrScannerRef.current) {
        qrScannerRef.current.stop();
        qrScannerRef.current.destroy();
        qrScannerRef.current = null;
      }
    };
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        className="videoWrapper"
        style={{ display: isScannerActive ? "block" : "none" }}
      >
        <video ref={videoElementRef} muted playsInline className="qrVideo" />
      </div>
      {/* Expose start/stop controls */}

      {!isScannerActive && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <FaQrcode size={300} />
          <ButtonIcon
            height={45}
            marginTop={2}
            color="#ffffff"
            backgroundColor={colors.primary}
            width={200}
            borderColor={colors.primary}
            buttonText="Start Scanner"
            onClick={startScanner}
          />
        </div>
      )}
    </div>
  );
}

export default QRCodeScanner;
